import { Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { DatatableService } from 'src/app/services/datatable.service';
import { CmRolesListComponent } from './cm-roles-list/cm-roles-list.component';

@Component({
  selector: 'app-cm-roles',
  templateUrl: './cm-roles.component.html',
  styleUrls: ['./cm-roles.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CmRolesComponent {

    @ViewChild(CmRolesListComponent) rolesListComponent!: CmRolesListComponent;

    constructor(private datatableService: DatatableService) {}

    ngAfterViewInit(): void {
      this.datatableService.init('kt_role_view');

      $(document).ready(() => {
        $('.dt-layout-row:first-child').hide();
      });
    }

    // Handle role added event from modal
    onRoleAdded(): void {
      console.log('Role added successfully! Refreshing roles list...');

      // Refresh the roles listing
      // You can implement specific refresh logic here
      // For example, reload the page or refresh specific components

      // Option 1: Reload the current page
      // window.location.reload();

      // Option 2: Refresh specific data (if you have a roles service)
      // this.loadRoles();

      // Option 3: Emit an event to refresh child components
      // For now, we'll just log the success
      console.log('Roles list should be refreshed here');
    }

    // Handle role updated event from modal
    onRoleUpdated(): void {
      console.log('Role updated successfully! Refreshing roles list...');

      // Call the child component's method to refresh the list
      if (this.rolesListComponent) {
        this.rolesListComponent.onRoleUpdated();
      }
    }

}
